import { render, staticRenderFns } from "./UpdateVendeurLineupForm.vue?vue&type=template&id=37e0ff92&scoped=true&"
import script from "./UpdateVendeurLineupForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateVendeurLineupForm.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateVendeurLineupForm.vue?vue&type=style&index=0&id=37e0ff92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0ff92",
  null
  
)

export default component.exports